import React, { useState } from "react";
import "./styles/TableauAnnexe2.css";

function TableauAnnexe2({
  formData,
  setFormData,
  handleCheckboxChangeTabeleau,
}) {
  const [visiblePeriodicity, setVisiblePeriodicity] = useState({});

  const handleMouseEnter = (...keys) => {
    setVisiblePeriodicity((prev) => {
      const updated = { ...prev };
      keys.forEach((key) => {
        updated[key] = true;
      });
      return updated;
    });
  };

  const handleMouseLeave = (...keys) => {
    setVisiblePeriodicity((prev) => {
      const updated = { ...prev };
      keys.forEach((key) => {
        updated[key] = false;
      });
      return updated;
    });
  };

  return (
    <div className="Annexe2">
      {" "}
      <table style={{ borderCollapse: "collapse", width: "100%" }}>
        <thead>
          <tr>
            <th
              style={{
                border: "1px solid black",
                padding: "8px",
                textAlign: "left",
              }}
            >
              NATURE DES OBLIGATIONS RESPECTIVES
            </th>
            <th
              style={{
                border: "1px solid black",
                padding: "8px",
                textAlign: "center",
              }}
            >
              Cabinet
            </th>
            <th
              style={{
                border: "1px solid black",
                padding: "8px",
                textAlign: "center",
              }}
            >
              Client
            </th>
            <th
              style={{
                border: "1px solid black",
                padding: "8px",
                textAlign: "center",
              }}
            >
              Autre intervenant
            </th>
            <th
              style={{
                border: "1px solid black",
                padding: "8px",
                textAlign: "center",
              }}
            >
              {" "}
              <p>Périodicité</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr style={{ fontWeight: "bold" }}>
            1. MISSION DE PRESENTATION DE COMPTES
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Organisation de la comptabilité
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="odlc_cac_a2"
                checked={formData.odlc_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="odlc_clc_a2"
                checked={formData.odlc_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="odlc_aic_a2"
                checked={formData.odlc_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("odlc_pa2")}
              onMouseLeave={() => handleMouseLeave("odlc_pa2")}
            >
              {visiblePeriodicity["odlc_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="odlc_pa2"
                        value={value}
                        checked={formData.odlc_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.odlc_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            odlc_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.odlc_pa2) &&
                formData.odlc_pa2.length > 0
                  ? formData.odlc_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Tenue du fichier des immobilisations et amortissements
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tdf_cac_a2"
                checked={formData.tdf_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tdf_clc_a2"
                checked={formData.tdf_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tdf_aic_a2"
                checked={formData.tdf_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("tdf_pa2")}
              onMouseLeave={() => handleMouseLeave("tdf_pa2")}
            >
              {visiblePeriodicity["tdf_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="tdf_pa2"
                        value={value}
                        checked={formData.tdf_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.tdf_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            tdf_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.tdf_pa2) && formData.tdf_pa2.length > 0
                  ? formData.tdf_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Stock
              <br /> • inventaire physique
              <br /> • valorisation des stocks
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <br />
              <input
                type="checkbox"
                name="sip_cac_a2"
                checked={formData.sip_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
              <br />
              <input
                type="checkbox"
                name="svdp_cac_a2"
                checked={formData.svdp_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <br />
              <input
                type="checkbox"
                name="sip_clc_a2"
                checked={formData.sip_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
              <br />
              <input
                type="checkbox"
                name="svdp_clc_a2"
                checked={formData.svdp_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <br />
              <input
                type="checkbox"
                name="sip_aic_a2"
                checked={formData.sip_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
              <br />
              <input
                type="checkbox"
                name="svdp_aic_a2"
                checked={formData.svdp_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("sip_pa2", "svdp_pa2")}
              onMouseLeave={() => handleMouseLeave("sip_pa2", "svdp_pa2")}
            >
              {visiblePeriodicity["sip_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="sip_pa2"
                        value={value}
                        checked={formData.sip_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.sip_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            sip_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}

              {visiblePeriodicity["svdp_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="svdp_pa2"
                        value={value}
                        checked={formData.svdp_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.svdp_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            svdp_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <br />
              <p style={{ margin: "0" }}>
                {Array.isArray(formData.sip_pa2) && formData.sip_pa2.length > 0
                  ? formData.sip_pa2.join("/")
                  : ""}
              </p>
              <p style={{ margin: "0" }}>
                {Array.isArray(formData.svdp_pa2) &&
                formData.svdp_pa2.length > 0
                  ? formData.svdp_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Justification des comptes clients et fournisseurs
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="jdc_cac_a2"
                checked={formData.jdc_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="jdc_clc_a2"
                checked={formData.jdc_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="jdc_aic_a2"
                checked={formData.jdc_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("jdc_pa2")}
              onMouseLeave={() => handleMouseLeave("jdc_pa2")}
            >
              {visiblePeriodicity["jdc_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="jdc_pa2"
                        value={value}
                        checked={formData.jdc_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.jdc_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            jdc_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.jdc_pa2) && formData.jdc_pa2.length > 0
                  ? formData.jdc_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Contrôle de TVA : rapprochement comptabilité/bases déclarées
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdt_cac_a2"
                checked={formData.cdt_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdt_clc_a2"
                checked={formData.cdt_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdt_aic_a2"
                checked={formData.cdt_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("cdt_pa2")}
              onMouseLeave={() => handleMouseLeave("cdt_pa2")}
            >
              {visiblePeriodicity["cdt_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="cdt_pa2"
                        value={value}
                        checked={formData.cdt_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.cdt_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            cdt_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.cdt_pa2) && formData.cdt_pa2.length > 0
                  ? formData.cdt_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Collecte des éléments concourant aux écritures d’inventaire <br />{" "}
              de fin d’exercice et enregistrement (dépréciation d’actifs, <br />
              montant des provisions, etc.)
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cedc_cac_a2"
                checked={formData.cedc_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cedc_clc_a2"
                checked={formData.cedc_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cedc_aic_a2"
                checked={formData.cedc_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("cedc_pa2")}
              onMouseLeave={() => handleMouseLeave("cedc_pa2")}
            >
              {visiblePeriodicity["cedc_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="cedc_pa2"
                        value={value}
                        checked={formData.cedc_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.cedc_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            cedc_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.cedc_pa2) &&
                formData.cedc_pa2.length > 0
                  ? formData.cedc_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Contrôles par sondages de pièces justificatives <br />
              Rapprochement avec les pièces justificatives externes <br />{" "}
              Recoupement avec les pièces justificatives internes
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cps_cac_a2"
                checked={formData.cps_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cps_clc_a2"
                checked={formData.cps_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cps_aic_a2"
                checked={formData.cps_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("cps_pa2")}
              onMouseLeave={() => handleMouseLeave("cps_pa2")}
            >
              {visiblePeriodicity["cps_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="cps_pa2"
                        value={value}
                        checked={formData.cps_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.cps_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            cps_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.cps_pa2) && formData.cps_pa2.length > 0
                  ? formData.cps_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>

          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Justification des soldes et contrôles de cohérence <br />
              des principaux comptes
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="jds_cac_a2"
                checked={formData.jds_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="jds_clc_a2"
                checked={formData.jds_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="jds_aic_a2"
                checked={formData.jds_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("jds_pa2")}
              onMouseLeave={() => handleMouseLeave("jds_pa2")}
            >
              {visiblePeriodicity["jds_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="jds_pa2"
                        value={value}
                        checked={formData.jds_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.jds_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            jds_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.jds_pa2) && formData.jds_pa2.length > 0
                  ? formData.jds_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Examen critique des comptes annuels
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ecdc_cac_a2"
                checked={formData.ecdc_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ecdc_clc_a2"
                checked={formData.ecdc_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ecdc_aic_a2"
                checked={formData.ecdc_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("ecdc_pa2")}
              onMouseLeave={() => handleMouseLeave("ecdc_pa2")}
            >
              {visiblePeriodicity["ecdc_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="ecdc_pa2"
                        value={value}
                        checked={formData.ecdc_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.ecdc_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            ecdc_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.ecdc_pa2) &&
                formData.ecdc_pa2.length > 0
                  ? formData.ecdc_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Etablissement des comptes annuels <br /> (bilan, compte de
              résultat et annexe comptable)
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="edca_cac_a2"
                checked={formData.edca_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="edca_clc_a2"
                checked={formData.edca_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="edca_aic_a2"
                checked={formData.edca_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("edca_pa2")}
              onMouseLeave={() => handleMouseLeave("edca_pa2")}
            >
              {visiblePeriodicity["edca_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="edca_pa2"
                        value={value}
                        checked={formData.edca_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.edca_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            edca_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.edca_pa2) &&
                formData.edca_pa2.length > 0
                  ? formData.edca_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>

          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Tenue des registres légaux comptables <br />
              Appréciation de la régularité en la forme <br /> de la
              comptabilité Contrôle par sondages <br /> des enregistrements
              comptables
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tdrl_cac_a2"
                checked={formData.tdrl_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tdrl_clc_a2"
                checked={formData.tdrl_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tdrl_aic_a2"
                checked={formData.tdrl_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("tdrl_pa2")}
              onMouseLeave={() => handleMouseLeave("tdrl_pa2")}
            >
              {visiblePeriodicity["tdrl_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="tdrl_pa2"
                        value={value}
                        checked={formData.tdrl_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.tdrl_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            tdrl_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.tdrl_pa2) &&
                formData.tdrl_pa2.length > 0
                  ? formData.tdrl_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Documents comptables (journal centralisateur, <br /> journaux,
              grands livres, balances) :
              <br /> • édition
              <br /> • archivage
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <br />
              <input
                type="checkbox"
                name="dce_cac_a2"
                checked={formData.dce_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
              <br />
              <input
                type="checkbox"
                name="dca_cac_a2"
                checked={formData.dca_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <br />
              <input
                type="checkbox"
                name="dce_clc_a2"
                checked={formData.dce_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
              <br />
              <input
                type="checkbox"
                name="dca_clc_a2"
                checked={formData.dca_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <br />
              <input
                type="checkbox"
                name="dce_aic_a2"
                checked={formData.dce_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
              <br />
              <input
                type="checkbox"
                name="dca_aic_a2"
                checked={formData.dca_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("dce_pa2", "dca_pa2")}
              onMouseLeave={() => handleMouseLeave("dce_pa2", "dca_pa2")}
            >
              {visiblePeriodicity["dce_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="dce_pa2"
                        value={value}
                        checked={formData.dce_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.dce_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            dce_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}

              {visiblePeriodicity["dca_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="dca_pa2"
                        value={value}
                        checked={formData.dca_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.dca_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            dca_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <br />
              <p style={{ margin: "0" }}>
                {Array.isArray(formData.dce_pa2) && formData.dce_pa2.length > 0
                  ? formData.dce_pa2.join("/")
                  : ""}
              </p>
              <p style={{ margin: "0" }}>
                {Array.isArray(formData.dca_pa2) && formData.dca_pa2.length > 0
                  ? formData.dca_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>
          {/* ------------------------ TABLEAU --------------------------------- */}
          {/* ------------------------ TABLEAU --------------------------------- */}
          {/* ------------------------ TABLEAU --------------------------------- */}
          <tr style={{ fontWeight: "bold" }}>2. AUTRES INTERVENTIONS</tr>
          <tr style={{ fontWeight: "bold" }}>
            Intervention en matière comptable (travaux liés à la tenue de la
            comptabilité)
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Elaboration et mise à jour du plan comptable
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="eem_cac_a2"
                checked={formData.eem_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="eem_clc_a2"
                checked={formData.eem_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="eem_aic_a2"
                checked={formData.eem_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("eem_pa2")}
              onMouseLeave={() => handleMouseLeave("eem_pa2")}
            >
              {visiblePeriodicity["eem_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="eem_pa2"
                        value={value}
                        checked={formData.eem_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.eem_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            eem_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.eem_pa2) && formData.eem_pa2.length > 0
                  ? formData.eem_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>

          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Classement des pièces comptables, numérotation et vérification
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdp_cac_a2"
                checked={formData.cdp_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdp_clc_a2"
                checked={formData.cdp_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdp_aic_a2"
                checked={formData.cdp_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("cdp_pa2")}
              onMouseLeave={() => handleMouseLeave("cdp_pa2")}
            >
              {visiblePeriodicity["cdp_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="cdp_pa2"
                        value={value}
                        checked={formData.cdp_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.cdp_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            cdp_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.cdp_pa2) && formData.cdp_pa2.length > 0
                  ? formData.cdp_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>

          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Enregistrement de la comptabilité en :
              <br /> • Comptabilité de trésorerie
              <br /> • Ou comptabilité d’engagement
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <br />
              <input
                type="checkbox"
                name="edlc_cac_a2"
                checked={formData.edlc_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
              <br />
              <input
                type="checkbox"
                name="edlco_cac_a2"
                checked={formData.edlco_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <br />
              <input
                type="checkbox"
                name="edlc_clc_a2"
                checked={formData.edlc_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
              <br />
              <input
                type="checkbox"
                name="edlco_clc_a2"
                checked={formData.edlco_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <br />
              <input
                type="checkbox"
                name="edlc_aic_a2"
                checked={formData.edlc_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
              <br />
              <input
                type="checkbox"
                name="edlco_aic_a2"
                checked={formData.edlco_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("edlc_pa2", "edlco_pa2")}
              onMouseLeave={() => handleMouseLeave("edlc_pa2", "edlco_pa2")}
            >
              {visiblePeriodicity["edlc_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="edlc_pa2"
                        value={value}
                        checked={formData.edlc_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.edlc_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            edlc_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}

              {visiblePeriodicity["edlco_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="edlco_pa2"
                        value={value}
                        checked={formData.edlco_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.edlco_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            edlco_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <br />
              <p style={{ margin: "0" }}>
                {Array.isArray(formData.edlc_pa2) &&
                formData.edlc_pa2.length > 0
                  ? formData.edlc_pa2.join("/")
                  : ""}
              </p>
              <p style={{ margin: "0" }}>
                {Array.isArray(formData.edlco_pa2) &&
                formData.edlco_pa2.length > 0
                  ? formData.edlco_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Etablissement des états de rapprochements bancaires
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ededr_cac_a2"
                checked={formData.ededr_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ededr_clc_a2"
                checked={formData.ededr_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ededr_aic_a2"
                checked={formData.ededr_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("ededr_pa2")}
              onMouseLeave={() => handleMouseLeave("ededr_pa2")}
            >
              {visiblePeriodicity["ededr_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="ededr_pa2"
                        value={value}
                        checked={formData.ededr_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.ededr_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            ededr_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.ededr_pa2) &&
                formData.ededr_pa2.length > 0
                  ? formData.ededr_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>

          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Caisse :
              <br /> • Comptabilité de trésorerie
              <br /> • Saisie des opérations de caisse
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <br />
              <input
                type="checkbox"
                name="ctdd_cac_a2"
                checked={formData.ctdd_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
              <br />
              <input
                type="checkbox"
                name="csdo_cac_a2"
                checked={formData.csdo_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <br />
              <input
                type="checkbox"
                name="ctdd_clc_a2"
                checked={formData.ctdd_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
              <br />
              <input
                type="checkbox"
                name="csdo_clc_a2"
                checked={formData.csdo_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <br />
              <input
                type="checkbox"
                name="ctdd_aic_a2"
                checked={formData.ctdd_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
              <br />
              <input
                type="checkbox"
                name="csdo_aic_a2"
                checked={formData.csdo_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("ctdd_pa2", "csdo_pa2")}
              onMouseLeave={() => handleMouseLeave("ctdd_pa2", "csdo_pa2")}
            >
              {visiblePeriodicity["ctdd_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="ctdd_pa2"
                        value={value}
                        checked={formData.ctdd_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.ctdd_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            ctdd_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}

              {visiblePeriodicity["csdo_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="csdo_pa2"
                        value={value}
                        checked={formData.csdo_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.csdo_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            csdo_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <br />
              <p style={{ margin: "0" }}>
                {Array.isArray(formData.ctdd_pa2) &&
                formData.ctdd_pa2.length > 0
                  ? formData.ctdd_pa2.join("/")
                  : ""}
              </p>
              <br />
              <p style={{ margin: "0" }}>
                {Array.isArray(formData.csdo_pa2) &&
                formData.csdo_pa2.length > 0
                  ? formData.csdo_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Archivage des fichiers de la comptabilité informatisée
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="adf_cac_a2"
                checked={formData.adf_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="adf_clc_a2"
                checked={formData.adf_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="adf_aic_a2"
                checked={formData.adf_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("adf_pa2")}
              onMouseLeave={() => handleMouseLeave("adf_pa2")}
            >
              {visiblePeriodicity["adf_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="adf_pa2"
                        value={value}
                        checked={formData.adf_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.adf_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            adf_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.adf_pa2) && formData.adf_pa2.length > 0
                  ? formData.adf_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>
          <tr style={{ fontWeight: "bold" }}>
            Interventions en matière fiscale
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Constitution du FEC de l’exercice clos <br />
              et du fichier descriptif associé
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdfdc_cac_a2"
                checked={formData.cdfdc_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdfdc_clc_a2"
                checked={formData.cdfdc_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdfdc_aic_a2"
                checked={formData.cdfdc_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("cdfdc_pa2")}
              onMouseLeave={() => handleMouseLeave("cdfdc_pa2")}
            >
              {visiblePeriodicity["cdfdc_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="cdfdc_pa2"
                        value={value}
                        checked={formData.cdfdc_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.cdfdc_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            cdfdc_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.cdfdc_pa2) &&
                formData.cdfdc_pa2.length > 0
                  ? formData.cdfdc_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>

          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Constitution du FEC de l’exercice en cours <br /> et du fichier
              descriptif associé
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdfde_cac_a2"
                checked={formData.cdfde_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdfde_clc_a2"
                checked={formData.cdfde_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdfde_aic_a2"
                checked={formData.cdfde_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("cdfde_pa2")}
              onMouseLeave={() => handleMouseLeave("cdfde_pa2")}
            >
              {visiblePeriodicity["cdfde_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="cdfde_pa2"
                        value={value}
                        checked={formData.cdfde_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.cdfde_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            cdfde_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.cdfde_pa2) &&
                formData.cdfde_pa2.length > 0
                  ? formData.cdfde_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>

          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Archivage du FEC
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="adfec_cac_a2"
                checked={formData.adfec_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="adfec_clc_a2"
                checked={formData.adfec_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="adfec_aic_a2"
                checked={formData.adfec_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("adfec_pa2")}
              onMouseLeave={() => handleMouseLeave("adfec_pa2")}
            >
              {visiblePeriodicity["adfec_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="adfec_pa2"
                        value={value}
                        checked={formData.adfec_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.adfec_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            adfec_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.adfec_pa2) &&
                formData.adfec_pa2.length > 0
                  ? formData.adfec_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>

          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Etablissement des déclarations de résultat <br /> de fin
              d’exercice
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="eddr_cac_a2"
                checked={formData.eddr_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="eddr_clc_a2"
                checked={formData.eddr_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="eddr_aic_a2"
                checked={formData.eddr_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("eddr_pa2")}
              onMouseLeave={() => handleMouseLeave("eddr_pa2")}
            >
              {visiblePeriodicity["eddr_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="eddr_pa2"
                        value={value}
                        checked={formData.eddr_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.eddr_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            eddr_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.eddr_pa2) &&
                formData.eddr_pa2.length > 0
                  ? formData.eddr_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>

          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Etablissement des documents CGA ou AGA
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="edcoa_cac_a2"
                checked={formData.edcoa_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="edcoa_clc_a2"
                checked={formData.edcoa_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="edcoa_aic_a2"
                checked={formData.edcoa_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("edcoa_pa2")}
              onMouseLeave={() => handleMouseLeave("edcoa_pa2")}
            >
              {visiblePeriodicity["edcoa_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="edcoa_pa2"
                        value={value}
                        checked={formData.edcoa_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.edcoa_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            edcoa_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.edcoa_pa2) &&
                formData.edcoa_pa2.length > 0
                  ? formData.edcoa_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>

          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Etablissement des déclarations de TVA
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="edddt_cac_a2"
                checked={formData.edddt_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="edddt_clc_a2"
                checked={formData.edddt_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="edddt_aic_a2"
                checked={formData.edddt_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("edddt_pa2")}
              onMouseLeave={() => handleMouseLeave("edddt_pa2")}
            >
              {visiblePeriodicity["edddt_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="edddt_pa2"
                        value={value}
                        checked={formData.edddt_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.edddt_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            edddt_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.edddt_pa2) &&
                formData.edddt_pa2.length > 0
                  ? formData.edddt_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>

          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Etablissement des déclarations d’échanges <br /> de biens et de
              services (DEB et DES)
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="eddddb_cac_a2"
                checked={formData.eddddb_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="eddddb_clc_a2"
                checked={formData.eddddb_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="eddddb_aic_a2"
                checked={formData.eddddb_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("eddddb_pa2")}
              onMouseLeave={() => handleMouseLeave("eddddb_pa2")}
            >
              {visiblePeriodicity["eddddb_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="eddddb_pa2"
                        value={value}
                        checked={formData.eddddb_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.eddddb_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            eddddb_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.eddddb_pa2) &&
                formData.eddddb_pa2.length > 0
                  ? formData.eddddb_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Etablissement des autres déclarations fiscales :
              <br /> • déclarations liées aux salaires
              <br /> • taxe sur les véhicules de sociétés
              <br /> • déclaration des contrats de prêts
              <br /> • DAS2
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <br />
              <input
                type="checkbox"
                name="dlas_cac_a2"
                checked={formData.dlas_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
              <br />
              <input
                type="checkbox"
                name="tsrlv_cac_a2"
                checked={formData.tsrlv_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
              <br />
              <input
                type="checkbox"
                name="ddcdp_cac_a2"
                checked={formData.ddcdp_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
              <br />
              <input
                type="checkbox"
                name="das_cac_a2"
                checked={formData.das_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <br />
              <input
                type="checkbox"
                name="dlas_clc_a2"
                checked={formData.dlas_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
              <br />
              <input
                type="checkbox"
                name="tsrlv_clc_a2"
                checked={formData.tsrlv_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
              <br />
              <input
                type="checkbox"
                name="ddcdp_clc_a2"
                checked={formData.ddcdp_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
              <br />
              <input
                type="checkbox"
                name="das_clc_a2"
                checked={formData.das_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <br />
              <input
                type="checkbox"
                name="dlas_aic_a2"
                checked={formData.dlas_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
              <br />
              <input
                type="checkbox"
                name="tsrlv_aic_a2"
                checked={formData.tsrlv_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
              <br />
              <input
                type="checkbox"
                name="ddcdp_aic_a2"
                checked={formData.ddcdp_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
              <br />
              <input
                type="checkbox"
                name="das_aic_a2"
                checked={formData.das_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() =>
                handleMouseEnter(
                  "dlas_pa2",
                  "tsrlv_pa2",
                  "ddcdp_pa2",
                  "das_pa2"
                )
              }
              onMouseLeave={() =>
                handleMouseLeave(
                  "dlas_pa2",
                  "tsrlv_pa2",
                  "ddcdp_pa2",
                  "das_pa2"
                )
              }
            >
              {visiblePeriodicity["dlas_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="dlas_pa2"
                        value={value}
                        checked={formData.dlas_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.dlas_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            dlas_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}

              {visiblePeriodicity["tsrlv_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="tsrlv_pa2"
                        value={value}
                        checked={formData.tsrlv_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.tsrlv_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            tsrlv_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}

              {visiblePeriodicity["ddcdp_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="ddcdp_pa2"
                        value={value}
                        checked={formData.ddcdp_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.ddcdp_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            ddcdp_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}

              {visiblePeriodicity["das_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="das_pa2"
                        value={value}
                        checked={formData.das_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.das_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            das_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <br />
              <p style={{ margin: "0" }}>
                {Array.isArray(formData.dlas_pa2) &&
                formData.dlas_pa2.length > 0
                  ? formData.dlas_pa2.join("/")
                  : ""}
              </p>
              <p style={{ margin: "0" }}>
                {Array.isArray(formData.tsrlv_pa2) &&
                formData.tsrlv_pa2.length > 0
                  ? formData.tsrlv_pa2.join("/")
                  : ""}
              </p>
              <p style={{ margin: "0" }}>
                {Array.isArray(formData.ddcdp_pa2) &&
                formData.ddcdp_pa2.length > 0
                  ? formData.ddcdp_pa2.join("/")
                  : ""}
              </p>
              <p style={{ margin: "0" }}>
                {Array.isArray(formData.das_pa2) && formData.das_pa2.length > 0
                  ? formData.das_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Suivi des échéances de CFE
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cfe_cac_a2"
                checked={formData.cfe_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cfe_clc_a2"
                checked={formData.cfe_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cfe_aic_a2"
                checked={formData.cfe_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("cfe_pa2")}
              onMouseLeave={() => handleMouseLeave("cfe_pa2")}
            >
              {visiblePeriodicity["cfe_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="cfe_pa2"
                        value={value}
                        checked={formData.cfe_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.cfe_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            cfe_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.cfe_pa2) && formData.cfe_pa2.length > 0
                  ? formData.cfe_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Suivi des échéances de CVAE
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cvae_cac_a2"
                checked={formData.cvae_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cvae_clc_a2"
                checked={formData.cvae_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cvae_aic_a2"
                checked={formData.cvae_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("cvae_pa2")}
              onMouseLeave={() => handleMouseLeave("cvae_pa2")}
            >
              {visiblePeriodicity["cvae_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="cvae_pa2"
                        value={value}
                        checked={formData.cvae_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.cvae_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            cvae_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.cvae_pa2) &&
                formData.cvae_pa2.length > 0
                  ? formData.cvae_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Suivi des échéances IS
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="is_cac_a2"
                checked={formData.is_cac_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="is_clc_a2"
                checked={formData.is_clc_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="is_aic_a2"
                checked={formData.is_aic_a2 === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td
              style={{ border: "1px solid black", textAlign: "center" }}
              onMouseEnter={() => handleMouseEnter("is_pa2")}
              onMouseLeave={() => handleMouseLeave("is_pa2")}
            >
              {visiblePeriodicity["is_pa2"] && (
                <div>
                  {["M", "N", "T", "A", "P", "J", "ND"].map((value) => (
                    <label key={value} style={{ marginRight: "5px" }}>
                      <input
                        type="checkbox"
                        name="is_pa2"
                        value={value}
                        checked={formData.is_pa2?.includes(value) || false}
                        onChange={(e) => {
                          const selectedValues = formData.is_pa2 || [];
                          const updatedValues = e.target.checked
                            ? [...selectedValues, value]
                            : selectedValues.filter((v) => v !== value);

                          setFormData({
                            ...formData,
                            is_pa2: updatedValues,
                          });
                        }}
                      />
                      {value}
                    </label>
                  ))}
                </div>
              )}
              <p>
                {Array.isArray(formData.is_pa2) && formData.is_pa2.length > 0
                  ? formData.is_pa2.join("/")
                  : ""}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default TableauAnnexe2;
